document.addEventListener('DOMContentLoaded', function () {
  var targetPath = '/apps/bundles/bundle/147290';
  var blockedVariantId = 43263994953828;
  var maxAttempts = 40;
  var attempt = 0;
  var intervalTime = 800;
  var isBlockedVariantInCart = false;
  var observerStarted = false;
  var isProcessing = false;

  if (window.location.pathname !== targetPath) {
    return;
  }

  function disableAddButtons() {
    if (isProcessing) return;
    isProcessing = true;

    var buttons = document.querySelectorAll('.bundle-builder-app--bundle--product-add-button');

    buttons.forEach(function (button) {
      if (button.disabled) return;

      button.disabled = true;
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.5';
      button.setAttribute('aria-disabled', 'true');

      var label = button.querySelector('span span');
      if (label) {
        label.textContent = 'Added';
      }
    });

    setTimeout(function () {
      isProcessing = false;
    }, 300);
  }

  function observePopupButtons() {
    if (observerStarted) return;
    observerStarted = true;

    var observer = new MutationObserver(function (mutations) {
      if (!isBlockedVariantInCart) return;

      var hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });

      if (hasNewNodes) {
        disableAddButtons();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function checkCartAndDisable() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          return;
        }

        var hasBlockedVariant = cart.items.some(function (item) {
          return Number(item.variant_id) === blockedVariantId;
        });

        if (hasBlockedVariant) {
          isBlockedVariantInCart = true;
          disableAddButtons();
          observePopupButtons();
        }
      })
      .catch(function (error) {
        console.error('Cart check error:', error);
      });
  }

  function initInjectedCodeWatcher() {
    var interval = setInterval(function () {
      attempt++;

      var injectedBlock = document.querySelector('.bundle-builder-app--products--block');
      var addButtons = document.querySelectorAll('.bundle-builder-app--bundle--product-add-button');

      if (injectedBlock && addButtons.length) {
        clearInterval(interval);
        checkCartAndDisable();
      }

      if (attempt >= maxAttempts) {
        clearInterval(interval);
      }
    }, intervalTime);
  }

  initInjectedCodeWatcher();
});